import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-auto py-3" }
const _hoisted_2 = { class: "ml-2 py-3" }
const _hoisted_3 = ["onClick", "textContent"]
const _hoisted_4 = ["textContent"]

import { computed, onMounted, ref } from 'vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import { can, useDateTime } from '@/composables';
import { useOrganizationDocumentStore } from '@/store';
import { PERMISSIONS, STATUS_DATA_EXPORT } from '@/enum';

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationDataExportDocuments',
  setup(__props) {

const organizationDocumentsStore = useOrganizationDocumentStore();

const show = ref(false);

onMounted(() => init());

const init = async () => {
  await getDocuments();
  show.value = true;
};

const getDocuments = async () => {
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_INDEX])) await organizationDocumentsStore.getOrganizationDataExports();
  else doFailUnauthorized('view');
};

const newDataExportIsAvailable = computed(() => {
  const status = organizationDocumentsStore.dataExport.status;
  return status === STATUS_DATA_EXPORT.PROCESSED || status === STATUS_DATA_EXPORT.FAILED || status === null;
});

const deleteDataExportIsAvailable = computed(() => organizationDocumentsStore.dataExport.documents.length > 0);

const messageTable = computed(() => {
  const { status } = organizationDocumentsStore.dataExport;

  if (status === STATUS_DATA_EXPORT.SCRUBBED) {
    return 'Data has been deleted.';
  }

  if (status === STATUS_DATA_EXPORT.PROCESSING || status === STATUS_DATA_EXPORT.PENDING) {
    return 'Data is exporting';
  }

  return 'No documents';
});

const doToast = (summary: string, detail: string) => {
  organizationDocumentsStore.doToast(detail, summary);
};

const doFailUnauthorized = (action: string) => {
  organizationDocumentsStore.doToast(`User unauthorized to ${action} documents.`, 'Error');
};

const onExportDocument = async () => {
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_GENERATE_DATA_EXPORT])) {
    const message = await organizationDocumentsStore.generateDataExport();
    doToast('Exporting', message.message);
    getDocuments();
  } else {
    doFailUnauthorized('export');
  }
};

const onDeleteDocument: () => Promise<void> = async () => {
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_DESTROY])) {
    await organizationDocumentsStore.deleteDataExport();
    getDocuments();
    doToast('Removed', 'Document has been removed');
  } else {
    doFailUnauthorized('delete');
  }
};

const onDownloadDocument = async (id: number, name: string) => {
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_DOWNLOAD])) {
    await organizationDocumentsStore.downloadGeneralDocument(id, name);
    doToast('Downloaded', 'Document successfully downloaded');
  } else {
    doFailUnauthorized('download');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_AppButton, {
          type: "primary",
          text: "Delete Export Files",
          "icon-left": "delete",
          disabled: !deleteDataExportIsAvailable.value,
          onClick: onDeleteDocument
        }, null, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AppButton, {
          type: "primary",
          text: "New Data Export",
          "icon-left": "cloud-upload",
          disabled: !newDataExportIsAvailable.value,
          onClick: onExportDocument
        }, null, 8, ["disabled"])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: _unref(organizationDocumentsStore).dataExport.documents,
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: _unref(organizationDocumentsStore).loading,
        "responsive-layout": "scroll",
        "scroll-height": "440px"
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(messageTable.value), 1)
        ]),
        default: _withCtx(() => [
          (show.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  field: "name",
                  header: "Filename"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("a", {
                      class: "cloud-download",
                      onClick: ($event: any) => (onDownloadDocument(data.id, data.name)),
                      textContent: _toDisplayString(data.name)
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "created_at",
                  header: "Created"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.created_at))
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _: 1
  }))
}
}

})